// extracted by mini-css-extract-plugin
export var chip = "_54-0";
export var filterDropdown = "_54-5";
export var filterItem = "_54-6";
export var icon = "_54-1";
export var removeButton = "_54-3";
export var removeIcon = "_54-4";
export var separator = "_54-2";